import { useState } from "react";
import { CollectionCalendar } from "@/components/backOffice/collection/collectionCalendar";
import { CollectionHeader } from "@/components/backOffice/collection/collectionHeader";
import { CollectionFilters } from "@/components/backOffice/collection/collectionFilters";

export const CollectionPage = () => {
  const [selectedPickupZoneId, setSelectedPickupZoneId] = useState<string | null>(null);
  const [search, setSearch] = useState("");

  return (
    <div className="flex h-screen w-full flex-1 flex-col gap-4 p-2 sm:p-8">
      <CollectionHeader />
      <CollectionFilters
        setSelectedPickupZoneId={setSelectedPickupZoneId}
        selectedPickupZoneId={selectedPickupZoneId}
        search={search}
        setSearch={setSearch}
      />
      <CollectionCalendar selectedPickupZoneId={selectedPickupZoneId} search={search} />
    </div>
  );
};
